import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/playfair-display/400-italic.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/500.css";
import "@fontsource/manrope/600.css";
import "@fontsource/great-vibes/400.css";

import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import CreateCertificatePage from "@/pages/CreateCertificatePage";
import CheckoutPage from "@/pages/CheckoutPage";
import ProofPage from "@/pages/ProofPage";
import SharePage from "@/pages/SharePage";
import AboutPage from "@/pages/AboutPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import CopyrightPage from "@/pages/CopyrightPage";
import MarkAsEndedPage from "@/pages/MarkAsEndedPage";
import AdminPage from "@/pages/AdminPage";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          {/* Public Routes with Navbar/Footer */}
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/create" element={<MainLayout><CreateCertificatePage /></MainLayout>} />
          <Route path="/checkout/:certificateId" element={<MainLayout><CheckoutPage /></MainLayout>} />
          <Route path="/proof/:certificateId" element={<MainLayout><ProofPage /></MainLayout>} />
          <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
          <Route path="/terms" element={<MainLayout><TermsPage /></MainLayout>} />
          <Route path="/privacy" element={<MainLayout><PrivacyPage /></MainLayout>} />
          <Route path="/disclaimer" element={<MainLayout><DisclaimerPage /></MainLayout>} />
          <Route path="/copyright" element={<MainLayout><CopyrightPage /></MainLayout>} />
          <Route path="/mark-as-ended" element={<MainLayout><MarkAsEndedPage /></MainLayout>} />
          
          {/* Share Page (view only, minimal layout) */}
          <Route path="/share/:certificateId" element={<SharePage />} />
          
          {/* Admin Route (no public navbar/footer) */}
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

// Main Layout with Navbar and Footer
const MainLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </>
  );
};

export default App;
